import { useLayoutEffect } from "react";
import { canUseDOM } from "./utils";
const useIsoLayoutEffect = canUseDOM ? useLayoutEffect : () => void 0;
export { useIsoLayoutEffect as useLayoutEffect };
//# sourceMappingURL=use-layout-effect.js.map